var React = require('react');

function IconYoutube (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"17","cy":"17","r":"17","key":0}),React.createElement("path",{"d":"M24.6465 13.5371C24.4707 12.834 23.9141 12.2773 23.2402 12.1016C21.9805 11.75 17 11.75 17 11.75C17 11.75 11.9902 11.75 10.7305 12.1016C10.0566 12.2773 9.5 12.834 9.32422 13.5371C8.97266 14.7676 8.97266 17.4043 8.97266 17.4043C8.97266 17.4043 8.97266 20.0117 9.32422 21.2715C9.5 21.9746 10.0566 22.502 10.7305 22.6777C11.9902 23 17 23 17 23C17 23 21.9805 23 23.2402 22.6777C23.9141 22.502 24.4707 21.9746 24.6465 21.2715C24.998 20.0117 24.998 17.4043 24.998 17.4043C24.998 17.4043 24.998 14.7676 24.6465 13.5371ZM15.3594 19.7773V15.0312L19.5195 17.4043L15.3594 19.7773Z","fill":"white","key":1})]);
}

IconYoutube.defaultProps = {"width":"34","height":"34","viewBox":"0 0 34 34","fill":"none"};

module.exports = IconYoutube;

IconYoutube.default = IconYoutube;
